import * as _ from "lodash"

import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField,
    ISearchRequestSubset,
    IProfileFilter,
    ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {WB_ProductTypeRow} from "../PA.Core/PAdbSchemaRows";


const vWB_Prod_Fields: { [id: string]: ISearchProviderField } = {
    WB_PROD_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product WB Id',
            columnResourceName: 'colProdWBId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Master Data Set WB Id',
            columnResourceName: 'colMDSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_PRDM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Product Type WB Id',
            columnResourceName: 'colPrdMId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'ID', columnResourceName: 'colProdId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Name', columnResourceName: 'colProdName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    PRODUCT_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Type Id', columnResourceName: 'colLevel', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PRODUCT_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Type Name', columnResourceName: 'colLevel', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Source', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    CONSUMER_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Consumer UPC', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    STATUS_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Status', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    KEY_SET: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Key Set', columnResourceName: 'colKeySet', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    BASE_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Base UOM', columnResourceName: 'colBaseUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    ORDER_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Order UOM', columnResourceName: 'colOrderUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    CASE_PACK_SIZE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Case/Pack Size',
            columnResourceName: 'colCaseSize',
            alignment: HorizAlignment.Right
        },
        domainOptions: {maxLength: 10}
    },
    NET_WEIGHT: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Net Weight', columnResourceName: 'colNetWeight', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    GROSS_WEIGHT: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Gross Weight',
            columnResourceName: 'colGrossWeight',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    WEIGHT_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Weight UOM', columnResourceName: 'colWeightUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    UNIT_SIZE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Unit Size', columnResourceName: 'colUnitSize', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    UNIT_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Unit UOM', columnResourceName: 'colUnitUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    VOLUME_SIZE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Volume Size', columnResourceName: 'colVolumeSize', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    VOLUME_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Volume UOM', columnResourceName: 'colVolumeUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    NET_CONTENTS: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Net Contents', columnResourceName: 'colContents', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    CONTENT_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Content UOM', columnResourceName: 'colContentUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'wb Sales Area',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area Id',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area Name',
            columnResourceName: 'colSalesAreaName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Sales Org',
            columnResourceName: 'colSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SalesOrg Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrgName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },

    MANUAL_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: {columnName: 'Manual Flag', columnResourceName: 'colManual', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    }

}

const vWB_Product_KeyFields =
    {
        id: 'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name: 'PRODUCT_NAME'
    }

class ProductManagerSearchProvider
    implements ISearchProvider {

    _WB_MDSET_ID: number
    _PRODUCT_TYPE: string
    _Profile: ISearchProfile

    constructor(wbMDSetId: number, productType: string, profile: ISearchProfile) {
        this._WB_MDSET_ID = wbMDSetId
        this._PRODUCT_TYPE = productType
        this._Profile = profile
    }

    get keyFields() {
        return vWB_Product_KeyFields
    }

    get searchProviderFields() {
        return vWB_Prod_Fields
    }


    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            requestSpec.where.WB_MDSET_ID = this._WB_MDSET_ID
            requestSpec.where.PRODUCT_TYPE = this._PRODUCT_TYPE

            requestSpec.where.WB_PRDM_ID = this._Profile.productTypeRow?.cif.WB_PRDM_ID


            let findRequest = SearchUtils.makeSearchRequest(requestSpec,
                'vUI_Product_Manager_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let joinColumns = _.filter(this._Profile.profileDisplayFields, aField => _.isObject(aField));
                    let joinFields = _.flatMap(joinColumns, 'fields');
                    let singleFields = _.filter(this._Profile.profileDisplayFields, aField => !_.isObject(aField));
                    let displayFields = _.uniq(_.concat(joinFields, singleFields, Object.values(this.keyFields)));

                    function unique(arr: any[], keyProps: any[]) {
                        const kvArray: any[][] = arr.map(entry => {
                            const key = keyProps.map(k => entry[k]).join('|');
                            return [key, entry];
                        });

                        const map = new Map(kvArray);
                        return Array.from(map.values());
                    }

                    resolve(unique(res, displayFields))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({
                    where: {
                        WB_MDSET_ID: this._WB_MDSET_ID,
                        PRODUCT_TYPE: this._PRODUCT_TYPE
                    }
                },
                'vUI_Product_Manager_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}

class ProductManagerSearchProfile
    implements ISearchProfile {

    constructor(wbMDSetId: number, productTypeId: string, productTypeRow: WB_ProductTypeRow) {
        this.wbMasterDataSetId = wbMDSetId
        this.ProductTypeId = productTypeId
        this.ProductTypeRow = productTypeRow

        this.aSearchProvider = new ProductManagerSearchProvider(wbMDSetId, productTypeId, this)
    }

    wbMasterDataSetId: number
    ProductTypeId: string
    ProductTypeRow: WB_ProductTypeRow

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Default Profile"
    renderOptions = {ui5ResourceId: "ProductManagerSearchProfile"}

    get productTypeRow(): WB_ProductTypeRow {
        return this.ProductTypeRow
    }

    get profileFilter(): IProfileFilter[] {

        let coreFilters = [
            {profileFilterName: 'Product Name', searchProviderFieldId: 'PRODUCT_NAME', renderOptions: {}},
            {profileFilterName: 'Product ID', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {}}]

        let salesOrgFilters = [
            {
                profileFilterName: 'Sales Org',
                searchProviderFieldId: 'SALESORG_NAME',
                bMultiSelect: true,
                renderOptions: {}
            },
            {
                profileFilterName: 'Sales Area',
                searchProviderFieldId: 'SALESAREA_NAME',
                bMultiSelect: true,
                renderOptions: {}
            }]


        return [
            ...coreFilters, ...salesOrgFilters
        ]
    }

    get profileDisplayFields(): string[] {

        let coreDisplayFields = [
            "PRODUCT_ID",
            "PRODUCT_NAME",
            "KEY_SET",
            "SOURCE_ID"
        ]

        let salesAreaFields = [
            'SALESORG_NAME',
            'SALESAREA_NAME'
        ]

        let consumerUPCFields: string[] = [
            'CONSUMER_UPC'
        ]

        let statusFields: string[] = [
            "STATUS_CODE"
        ]

        let uomFields: string[] = [
            "BASE_UOM",
            "ORDER_UOM",
        ]

        let sizesFields: string[] = [
            "CASE_PACK_SIZE"
        ]

        let size_uomFields = [
            {columnTitle: "Unit", fields: ['UNIT_SIZE', 'UNIT_UOM'], seperator: " ", alignment: HorizAlignment.Center},
            {
                columnTitle: "Net Weight",
                fields: ['NET_WEIGHT', 'WEIGHT_UOM'],
                seperator: " ",
                alignment: HorizAlignment.Center
            },
            {
                columnTitle: "Gross Weight",
                fields: ['GROSS_WEIGHT', 'WEIGHT_UOM'],
                seperator: " ",
                alignment: HorizAlignment.Center
            },
            {
                columnTitle: "Volume",
                fields: ['VOLUME_SIZE', 'VOLUME_UOM'],
                seperator: " ",
                alignment: HorizAlignment.Center
            },
            {
                columnTitle: "Net Contents",
                fields: ['NET_CONTENTS', 'CONTENT_UOM'],
                seperator: " ",
                alignment: HorizAlignment.Center
            },


        ]

        let manualIndFields: string[] = ["MANUAL_IND"]

        let configuredFields: string[] = []

        if (_.isEmpty(this.ProductTypeRow))
            return [
                ...coreDisplayFields
            ]

        let rv: any[] = _.clone(coreDisplayFields)
        let pt = this.ProductTypeRow
        if (pt.cif.SALESAREA_SEARCHABLE_IND == '1')
            rv = [...rv, ...salesAreaFields]

        if (pt.cif.UOM_SEARCHABLE_IND == '1')
            rv = [...rv, ...uomFields]

        if (pt.cif.SIZES_SEARCHABLE_IND == '1')
            rv = [...rv, ...sizesFields]

        if (pt.cif.SIZES_SEARCHABLE_IND == '1' && pt.cif.UOM_SEARCHABLE_IND == '1')
            rv = [...rv, ...size_uomFields]

        if (pt.cif.CONSUMER_UPC_SEARCHABLE_IND == '1')
            rv = [...rv, ...consumerUPCFields]

        if (pt.cif.STATUS_SEARCHABLE_IND == '1') {
            rv = [...rv, ...statusFields]
        }


        let dctConfiguredFields = _.keyBy(this.ProductTypeRow.HeaderSearchFields, (a) => a)
        _.forEach(configuredFields, (a) => {
            if (a in dctConfiguredFields)
                rv.push(a)
        })

        return _.uniq([...rv, ...manualIndFields])
    }

    profileHyperlinkFields = ['PRODUCT_ID']
    profileSortIdDefault = ""
    profileSorts: ISearchSort[] = []


    get profileSearchProvider() {
        return this.aSearchProvider
    }
}


export class ProductManagerSearch
    implements ISearch {
    constructor(wbMDSetId: number,
                productType: string,
                productTypeRow: WB_ProductTypeRow,
                options?: any) {

        this.searchProfiles = [new ProductManagerSearchProfile(wbMDSetId, productType, productTypeRow)]
    }

    searchName = "Select Product(s)"
    renderOptions = {ui5ResourceId: "ProductManagerSearch"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
